export default __webpack_public_path__ + "static/media/Background_00204.27e38a09.png";